import { useTheme } from "../../../context/useThemeContext";
import { FaRedo, FaUndo } from "react-icons/fa";
import { useEffect, useState } from "react";
import { LuTableOfContents } from "react-icons/lu";
import ToggleIconButton from "../../../components/buttons/toggleIconButton";
import { useGetEditor } from "../../../context/useEditorContext";
import useMainStore from "../../../stores/mainStore";
import { TopButton } from "./TopButton";
import { hexToRGBA } from "../../../utility/hexToRGB";

function TextRightContent() {
    const { theme } = useTheme();
    const editor = useGetEditor().editor.current;
    const showTableOfContents = useMainStore(
        (state) => state.data.showTableOfContents
    );
    const [updateActive, setUpdateActiveState] = useState(false); // Only for rerendering on selection change AND update

    const [headings, setHeadings] = useState<
        Array<{ pos: number; text: string; level: number }>
    >([]);
    const updateHeadings = () => {
        const headings_: Array<{
            pos: number;
            text: string;
            level: number;
        }> = [];
        editor?.state.doc.descendants((node, pos) => {
            if (node.type.name === "heading") {
                headings_.push({
                    pos,
                    text: node.textContent,
                    level: node.attrs.level,
                });
            }
        });

        setHeadings(() => headings_ || []);
    };

    // On every change and selection change, rerender
    useEffect(() => {
        const handleUpdate = () => {
            setUpdateActiveState((prev) => !prev);
            updateHeadings();
        };

        editor?.on("update", handleUpdate);
        editor?.on("selectionUpdate", handleUpdate);
        handleUpdate();

        return () => {
            editor?.off("update", handleUpdate);
            editor?.off("selectionUpdate", handleUpdate);
        };
    }, []);

    return (
        <div className="flex gap-2 items-center h-[34px] pl-2">
            <TopButton
                isDisabled={!editor?.can().undo()}
                icon={<FaUndo size={14} />}
                onClick={(e) => {
                    editor?.commands.undo();
                    editor?.commands.focus();
                }}
                alt="undo"
            />
            <TopButton
                isDisabled={!editor?.can().redo()}
                icon={<FaRedo size={14} />}
                onClick={(e) => {
                    editor?.commands.redo();
                    editor?.commands.focus();
                }}
                alt="redo"
            />
            {headings.length > 0 && (
                <ToggleIconButton
                    alt="Table of Contents"
                    size={{ x: 26, y: 26 }}
                    isActive={showTableOfContents}
                    activeBGColor={hexToRGBA(theme.headerColor, 1)}
                    activeIconColor={theme.fontColor[100]}
                    hoverBGInactive={hexToRGBA(theme.accentColor, 0.2)}
                    hoverBGActive={hexToRGBA(theme.accentColor, 0.2)}
                    hoverIconActive={theme.fontColor[50]}
                    hoverIconInactive={theme.fontColor[50]}
                    className={"flex-grow-0 "}
                    style={{
                        opacity: 1,
                        pointerEvents: "unset",
                    }}
                    icon={<LuTableOfContents size={20} />}
                    onClick={() => {
                        useMainStore
                            .getState()
                            .set.showTableOfContents(
                                (showTableOfContents) => !showTableOfContents
                            );
                    }}
                />
            )}
        </div>
    );
}

export default TextRightContent;
